<template>
  <div>
    <div class="r-text-body-small">
      <span>אם יש לך שאלה, אנחנו כאן </span>
      <link-button text="saving@riseup.co.il" @click="sendMailTo('saving@riseup.co.il')"/>
    </div>
  </div>
</template>

<script>
import LinkButton from '@/components/base/LinkButton';
import ExternalPagesActions from '@/mixins/ExternalPagesActions';

export default {
  name: 'Support',
  components: { LinkButton },
  mixins: [ExternalPagesActions],
};
</script>
